module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_0@3x.92272775.png";